/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Trove
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountIn,
  AccountOut,
  AddIntegrationParams,
  BodyAddIntegration,
  BodyExtractInvoice,
  BodyExtractTerms,
  DeleteWorkflowFeesSettingsParams,
  ExtractedFee,
  ExtractedInvoice,
  FeeInvoiceDetailsOut,
  FeePreviewOut,
  GetBankAccounts200,
  GetWorkflowFeesSettingsParams,
  HTTPValidationError,
  PaymentFeeCreateIn,
  PaymentFeeSettingsIn,
  PaymentFeeSettingsOut,
  Provider,
  SignupParams,
  TreasureInvoiceDetailsOut,
  TreasureInvoiceOut,
  UpdateWorkflowFeesSettingsParams
} from '../model';

import { customInstance } from '../../axios.ts';
import type { ErrorType , BodyType } from '../../axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Add Integration
 */
export const addIntegration = (
    provider: Provider,
    bodyAddIntegration: BodyType<BodyAddIntegration>,
    params: AddIntegrationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formUrlEncoded = new URLSearchParams();
formUrlEncoded.append(`token`, bodyAddIntegration.token);

      return customInstance<unknown>(
      {url: `/api/auth/initiate/${provider}/`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded,
        params, signal
    },
      options);
    }




export const getAddIntegrationMutationOptions = <TError = ErrorType<unknown | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addIntegration>>, TError,{provider: Provider;data: BodyType<BodyAddIntegration>;params: AddIntegrationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addIntegration>>, TError,{provider: Provider;data: BodyType<BodyAddIntegration>;params: AddIntegrationParams}, TContext> => {

const mutationKey = ['addIntegration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addIntegration>>, {provider: Provider;data: BodyType<BodyAddIntegration>;params: AddIntegrationParams}> = (props) => {
          const {provider,data,params} = props ?? {};

          return  addIntegration(provider,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof addIntegration>>>
    export type AddIntegrationMutationBody = BodyType<BodyAddIntegration>
    export type AddIntegrationMutationError = ErrorType<unknown | HTTPValidationError>

    /**
 * @summary Add Integration
 */
export const useAddIntegration = <TError = ErrorType<unknown | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addIntegration>>, TError,{provider: Provider;data: BodyType<BodyAddIntegration>;params: AddIntegrationParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addIntegration>>,
        TError,
        {provider: Provider;data: BodyType<BodyAddIntegration>;params: AddIntegrationParams},
        TContext
      > => {
      return useMutation(getAddIntegrationMutationOptions(options), queryClient);
    }
    /**
 * @summary Signup
 */
export const signup = (
    provider: Provider,
    params?: SignupParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/auth/signup/${provider}/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSignupQueryKey = (provider: Provider,
    params?: SignupParams,) => {
    return [
    `/api/auth/signup/${provider}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSignupQueryOptions = <TData = Awaited<ReturnType<typeof signup>>, TError = ErrorType<HTTPValidationError>>(provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSignupQueryKey(provider,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof signup>>> = ({ signal }) => signup(provider,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: provider !== null && provider !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SignupQueryResult = NonNullable<Awaited<ReturnType<typeof signup>>>
export type SignupQueryError = ErrorType<HTTPValidationError>


export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = ErrorType<HTTPValidationError>>(
 provider: Provider,
    params: undefined |  SignupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof signup>>,
          TError,
          Awaited<ReturnType<typeof signup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = ErrorType<HTTPValidationError>>(
 provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof signup>>,
          TError,
          Awaited<ReturnType<typeof signup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = ErrorType<HTTPValidationError>>(
 provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Signup
 */

export function useSignup<TData = Awaited<ReturnType<typeof signup>>, TError = ErrorType<HTTPValidationError>>(
 provider: Provider,
    params?: SignupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof signup>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSignupQueryOptions(provider,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Complete Oauth
 */
export const completeOauth = (
    provider: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/auth/complete/${provider}/`, method: 'GET', signal
    },
      options);
    }




export const getCompleteOauthQueryKey = (provider: string,) => {
    return [
    `/api/auth/complete/${provider}/`
    ] as const;
    }


export const getCompleteOauthQueryOptions = <TData = Awaited<ReturnType<typeof completeOauth>>, TError = ErrorType<HTTPValidationError>>(provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompleteOauthQueryKey(provider);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof completeOauth>>> = ({ signal }) => completeOauth(provider, requestOptions, signal);





   return  { queryKey, queryFn, enabled: provider !== null && provider !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompleteOauthQueryResult = NonNullable<Awaited<ReturnType<typeof completeOauth>>>
export type CompleteOauthQueryError = ErrorType<HTTPValidationError>


export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = ErrorType<HTTPValidationError>>(
 provider: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof completeOauth>>,
          TError,
          Awaited<ReturnType<typeof completeOauth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = ErrorType<HTTPValidationError>>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof completeOauth>>,
          TError,
          Awaited<ReturnType<typeof completeOauth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = ErrorType<HTTPValidationError>>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Complete Oauth
 */

export function useCompleteOauth<TData = Awaited<ReturnType<typeof completeOauth>>, TError = ErrorType<HTTPValidationError>>(
 provider: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof completeOauth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompleteOauthQueryOptions(provider,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Extract Invoice
 */
export const extractInvoice = (
    bodyExtractInvoice: BodyType<BodyExtractInvoice>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`invoice`, bodyExtractInvoice.invoice);

      return customInstance<ExtractedInvoice | null>(
      {url: `/api/extract/extract-invoice`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getExtractInvoiceMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractInvoice>>, TError,{data: BodyType<BodyExtractInvoice>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof extractInvoice>>, TError,{data: BodyType<BodyExtractInvoice>}, TContext> => {

const mutationKey = ['extractInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractInvoice>>, {data: BodyType<BodyExtractInvoice>}> = (props) => {
          const {data} = props ?? {};

          return  extractInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtractInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof extractInvoice>>>
    export type ExtractInvoiceMutationBody = BodyType<BodyExtractInvoice>
    export type ExtractInvoiceMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Extract Invoice
 */
export const useExtractInvoice = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractInvoice>>, TError,{data: BodyType<BodyExtractInvoice>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extractInvoice>>,
        TError,
        {data: BodyType<BodyExtractInvoice>},
        TContext
      > => {
      return useMutation(getExtractInvoiceMutationOptions(options), queryClient);
    }
    /**
 * @summary Extract Terms
 */
export const extractTerms = (
    bodyExtractTerms: BodyType<BodyExtractTerms>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`terms`, bodyExtractTerms.terms);

      return customInstance<ExtractedFee[]>(
      {url: `/api/extract/extract-terms`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getExtractTermsMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractTerms>>, TError,{data: BodyType<BodyExtractTerms>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof extractTerms>>, TError,{data: BodyType<BodyExtractTerms>}, TContext> => {

const mutationKey = ['extractTerms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extractTerms>>, {data: BodyType<BodyExtractTerms>}> = (props) => {
          const {data} = props ?? {};

          return  extractTerms(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtractTermsMutationResult = NonNullable<Awaited<ReturnType<typeof extractTerms>>>
    export type ExtractTermsMutationBody = BodyType<BodyExtractTerms>
    export type ExtractTermsMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Extract Terms
 */
export const useExtractTerms = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extractTerms>>, TError,{data: BodyType<BodyExtractTerms>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extractTerms>>,
        TError,
        {data: BodyType<BodyExtractTerms>},
        TContext
      > => {
      return useMutation(getExtractTermsMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Invoice
 */
export const getInvoice = (
    invoiceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TreasureInvoiceDetailsOut>(
      {url: `/api/invoices/invoice/${invoiceId}`, method: 'GET', signal
    },
      options);
    }




export const getGetInvoiceQueryKey = (invoiceId: string,) => {
    return [
    `/api/invoices/invoice/${invoiceId}`
    ] as const;
    }


export const getGetInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<HTTPValidationError>>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({ signal }) => getInvoice(invoiceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetInvoiceQueryError = ErrorType<HTTPValidationError>


export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoice>>,
          TError,
          Awaited<ReturnType<typeof getInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoice
 */

export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoiceQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get Invoices
 */
export const getInvoices = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TreasureInvoiceOut[]>(
      {url: `/api/invoices/invoices`, method: 'GET', signal
    },
      options);
    }




export const getGetInvoicesQueryKey = () => {
    return [
    `/api/invoices/invoices`
    ] as const;
    }


export const getGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoices>>, TError = ErrorType<HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) => getInvoices(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesQueryError = ErrorType<HTTPValidationError>


export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = ErrorType<HTTPValidationError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Invoices
 */

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get Bank Accounts
 */
export const getBankAccounts = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetBankAccounts200>(
      {url: `/api/payment-fees/accounts`, method: 'GET', signal
    },
      options);
    }




export const getGetBankAccountsQueryKey = () => {
    return [
    `/api/payment-fees/accounts`
    ] as const;
    }


export const getGetBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankAccounts>>> = ({ signal }) => getBankAccounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankAccounts>>>
export type GetBankAccountsQueryError = ErrorType<HTTPValidationError>


export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<HTTPValidationError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bank Accounts
 */

export function useGetBankAccounts<TData = Awaited<ReturnType<typeof getBankAccounts>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get Workflow Fees Settings
 */
export const getWorkflowFeesSettings = (
    params?: GetWorkflowFeesSettingsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaymentFeeSettingsOut | null>(
      {url: `/api/payment-fees/settings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkflowFeesSettingsQueryKey = (params?: GetWorkflowFeesSettingsParams,) => {
    return [
    `/api/payment-fees/settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkflowFeesSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = ErrorType<HTTPValidationError>>(params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkflowFeesSettingsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowFeesSettings>>> = ({ signal }) => getWorkflowFeesSettings(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkflowFeesSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkflowFeesSettings>>>
export type GetWorkflowFeesSettingsQueryError = ErrorType<HTTPValidationError>


export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = ErrorType<HTTPValidationError>>(
 params: undefined |  GetWorkflowFeesSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = ErrorType<HTTPValidationError>>(
 params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowFeesSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = ErrorType<HTTPValidationError>>(
 params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Workflow Fees Settings
 */

export function useGetWorkflowFeesSettings<TData = Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError = ErrorType<HTTPValidationError>>(
 params?: GetWorkflowFeesSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkflowFeesSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkflowFeesSettingsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update Workflow Fees Settings
 */
export const updateWorkflowFeesSettings = (
    paymentFeeSettingsIn: BodyType<PaymentFeeSettingsIn>,
    params?: UpdateWorkflowFeesSettingsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/payment-fees/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: paymentFeeSettingsIn,
        params, signal
    },
      options);
    }




export const getUpdateWorkflowFeesSettingsMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, TError,{data: BodyType<PaymentFeeSettingsIn>;params?: UpdateWorkflowFeesSettingsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, TError,{data: BodyType<PaymentFeeSettingsIn>;params?: UpdateWorkflowFeesSettingsParams}, TContext> => {

const mutationKey = ['updateWorkflowFeesSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, {data: BodyType<PaymentFeeSettingsIn>;params?: UpdateWorkflowFeesSettingsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  updateWorkflowFeesSettings(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkflowFeesSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>>
    export type UpdateWorkflowFeesSettingsMutationBody = BodyType<PaymentFeeSettingsIn>
    export type UpdateWorkflowFeesSettingsMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Update Workflow Fees Settings
 */
export const useUpdateWorkflowFeesSettings = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkflowFeesSettings>>, TError,{data: BodyType<PaymentFeeSettingsIn>;params?: UpdateWorkflowFeesSettingsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkflowFeesSettings>>,
        TError,
        {data: BodyType<PaymentFeeSettingsIn>;params?: UpdateWorkflowFeesSettingsParams},
        TContext
      > => {
      return useMutation(getUpdateWorkflowFeesSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Workflow Fees Settings
 */
export const deleteWorkflowFeesSettings = (
    params?: DeleteWorkflowFeesSettingsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/payment-fees/settings`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteWorkflowFeesSettingsMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, TError,{params?: DeleteWorkflowFeesSettingsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, TError,{params?: DeleteWorkflowFeesSettingsParams}, TContext> => {

const mutationKey = ['deleteWorkflowFeesSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, {params?: DeleteWorkflowFeesSettingsParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteWorkflowFeesSettings(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkflowFeesSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>>

    export type DeleteWorkflowFeesSettingsMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Delete Workflow Fees Settings
 */
export const useDeleteWorkflowFeesSettings = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>, TError,{params?: DeleteWorkflowFeesSettingsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkflowFeesSettings>>,
        TError,
        {params?: DeleteWorkflowFeesSettingsParams},
        TContext
      > => {
      return useMutation(getDeleteWorkflowFeesSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Fees For Customer
 */
export const getFeesForCustomer = (
    customerId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FeeInvoiceDetailsOut[]>(
      {url: `/api/payment-fees/for-customer/${customerId}`, method: 'GET', signal
    },
      options);
    }




export const getGetFeesForCustomerQueryKey = (customerId: string,) => {
    return [
    `/api/payment-fees/for-customer/${customerId}`
    ] as const;
    }


export const getGetFeesForCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = ErrorType<HTTPValidationError>>(customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeesForCustomerQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeesForCustomer>>> = ({ signal }) => getFeesForCustomer(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeesForCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getFeesForCustomer>>>
export type GetFeesForCustomerQueryError = ErrorType<HTTPValidationError>


export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = ErrorType<HTTPValidationError>>(
 customerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForCustomer>>,
          TError,
          Awaited<ReturnType<typeof getFeesForCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = ErrorType<HTTPValidationError>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForCustomer>>,
          TError,
          Awaited<ReturnType<typeof getFeesForCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = ErrorType<HTTPValidationError>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fees For Customer
 */

export function useGetFeesForCustomer<TData = Awaited<ReturnType<typeof getFeesForCustomer>>, TError = ErrorType<HTTPValidationError>>(
 customerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeesForCustomerQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get Fees For Invoice
 */
export const getFeesForInvoice = (
    invoiceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FeeInvoiceDetailsOut | null>(
      {url: `/api/payment-fees/for-invoice/${invoiceId}`, method: 'GET', signal
    },
      options);
    }




export const getGetFeesForInvoiceQueryKey = (invoiceId: string,) => {
    return [
    `/api/payment-fees/for-invoice/${invoiceId}`
    ] as const;
    }


export const getGetFeesForInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = ErrorType<HTTPValidationError>>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeesForInvoiceQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeesForInvoice>>> = ({ signal }) => getFeesForInvoice(invoiceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeesForInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getFeesForInvoice>>>
export type GetFeesForInvoiceQueryError = ErrorType<HTTPValidationError>


export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForInvoice>>,
          TError,
          Awaited<ReturnType<typeof getFeesForInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeesForInvoice>>,
          TError,
          Awaited<ReturnType<typeof getFeesForInvoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Fees For Invoice
 */

export function useGetFeesForInvoice<TData = Awaited<ReturnType<typeof getFeesForInvoice>>, TError = ErrorType<HTTPValidationError>>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeesForInvoice>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeesForInvoiceQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Preview Fee
 */
export const previewFee = (
    paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<FeePreviewOut[]>(
      {url: `/api/payment-fees/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentFeeCreateIn, signal
    },
      options);
    }




export const getPreviewFeeMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewFee>>, TError,{data: BodyType<PaymentFeeCreateIn>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewFee>>, TError,{data: BodyType<PaymentFeeCreateIn>}, TContext> => {

const mutationKey = ['previewFee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewFee>>, {data: BodyType<PaymentFeeCreateIn>}> = (props) => {
          const {data} = props ?? {};

          return  previewFee(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewFeeMutationResult = NonNullable<Awaited<ReturnType<typeof previewFee>>>
    export type PreviewFeeMutationBody = BodyType<PaymentFeeCreateIn>
    export type PreviewFeeMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Preview Fee
 */
export const usePreviewFee = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewFee>>, TError,{data: BodyType<PaymentFeeCreateIn>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewFee>>,
        TError,
        {data: BodyType<PaymentFeeCreateIn>},
        TContext
      > => {
      return useMutation(getPreviewFeeMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Fee
 */
export const createFee = (
    paymentFeeCreateIn: BodyType<PaymentFeeCreateIn>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/payment-fees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentFeeCreateIn, signal
    },
      options);
    }




export const getCreateFeeMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,{data: BodyType<PaymentFeeCreateIn>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,{data: BodyType<PaymentFeeCreateIn>}, TContext> => {

const mutationKey = ['createFee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFee>>, {data: BodyType<PaymentFeeCreateIn>}> = (props) => {
          const {data} = props ?? {};

          return  createFee(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFeeMutationResult = NonNullable<Awaited<ReturnType<typeof createFee>>>
    export type CreateFeeMutationBody = BodyType<PaymentFeeCreateIn>
    export type CreateFeeMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Create Fee
 */
export const useCreateFee = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,{data: BodyType<PaymentFeeCreateIn>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFee>>,
        TError,
        {data: BodyType<PaymentFeeCreateIn>},
        TContext
      > => {
      return useMutation(getCreateFeeMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Account
 */
export const getAccount = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<AccountOut | null>(
      {url: `/api/accounts/primary`, method: 'GET', signal
    },
      options);
    }




export const getGetAccountQueryKey = () => {
    return [
    `/api/accounts/primary`
    ] as const;
    }


export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = ErrorType<HTTPValidationError>


export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<HTTPValidationError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Account
 */

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update Account
 */
export const updateAccount = (
    accountIn: BodyType<AccountIn>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/accounts`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accountIn, signal
    },
      options);
    }




export const getUpdateAccountMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: BodyType<AccountIn>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: BodyType<AccountIn>}, TContext> => {

const mutationKey = ['updateAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccount>>, {data: BodyType<AccountIn>}> = (props) => {
          const {data} = props ?? {};

          return  updateAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccount>>>
    export type UpdateAccountMutationBody = BodyType<AccountIn>
    export type UpdateAccountMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Update Account
 */
export const useUpdateAccount = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccount>>, TError,{data: BodyType<AccountIn>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccount>>,
        TError,
        {data: BodyType<AccountIn>},
        TContext
      > => {
      return useMutation(getUpdateAccountMutationOptions(options), queryClient);
    }
    /**
 * @summary Refresh Account
 */
export const refreshAccount = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/accounts/refresh`, method: 'POST', signal
    },
      options);
    }




export const getRefreshAccountMutationOptions = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,void, TContext> => {

const mutationKey = ['refreshAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccount>>, void> = () => {


          return  refreshAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshAccountMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccount>>>

    export type RefreshAccountMutationError = ErrorType<HTTPValidationError>

    /**
 * @summary Refresh Account
 */
export const useRefreshAccount = <TError = ErrorType<HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshAccountMutationOptions(options), queryClient);
    }
